import * as z from "zod/v4";

// HA-563 / HA-943 network-printer address rule — mirrors the backend NetworkPrinterHost rule. bg-proxy approves a network
// printer by strict IPv4 address at port 9100 only, so the form takes an IPv4 address and nothing else: no hostname, no
// IPv6, no port field. Revisit if bg-proxy approves other ports or address kinds.
const IPV4 =
	/^((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/;

/** The only port bg-proxy approves a network printer on; the server sends it, the form has no field for it. */
export const NETWORK_PRINTER_PORT = 9100;

export function isValidIp(ip: string): boolean {
	return IPV4.test(ip.trim());
}

export const ipSchema = z
	.string()
	.trim()
	.min(1, "IP address is required")
	.refine(isValidIp, "Enter a valid IPv4 address");
